import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Label } from "@/components/ui/label";

interface FontOption {
  name: string;
  displayName: string;
  category: string;
}

const FONT_OPTIONS: FontOption[] = [
  { name: "Arial", displayName: "Arial", category: "Sans-serif" },
  { name: "Times New Roman", displayName: "Times New Roman", category: "Serif" },
  { name: "Courier New", displayName: "Courier New", category: "Monospace" },
  { name: "Impact", displayName: "Impact", category: "Display" },
  { name: "Comic Sans MS", displayName: "Comic Sans MS", category: "Casual" },
];

interface FontSelectorProps {
  value: string;
  onChange: (font: string) => void;
}

export function FontSelector({ value, onChange }: FontSelectorProps) {
  return (
    <div className="space-y-2">
      <Label className="text-xs font-normal text-muted-foreground">Font Family</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Select font..." />
        </SelectTrigger>
        <SelectContent>
          {FONT_OPTIONS.map((font) => (
            <SelectItem
              key={font.name}
              value={font.name}
              style={{ fontFamily: font.name }}
            >
              <div className="flex items-center justify-between w-full">
                <span style={{ fontFamily: font.name }}>
                  {font.displayName}
                </span>
                <span className="text-xs text-muted-foreground ml-2">
                  {font.category}
                </span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
